<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/1B21Ugi/tc-custom/9781426847950.jpg?1740859793647" alt="This image is the cover for the book Bought: The Greek's Baby"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Bought: The Greek's Baby
      </h1>
      <p class="bookDescription body article font2">
        <b>“A complex love story filled with betrayals, misunderstandings and secrets” from the <i>USA Today</i>–bestselling author of <i>The Christmas Love-Child</i> (CataRomance).</b><br/><br/>American beauty Eve Craig fell under the spell of powerful Talos Xenakis in a hot-blooded Athens encounter . . . <br/><br/>Three months later Eve has lost her innocence—and her memory!<br/><br/>But she has aroused Talos’s desire and his anger—she has betrayed him. So what better way to punish the woman who nearly ruined him, than marry—and destroy—her? Only she’s now carrying his love-child . . . <br/><br/>“Once this entertaining tale begins, Lucas does a terrific job of keeping the reader off-balance right to the end.” —Romantic Times
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Jennie Lucas
      </h2>
      
      <p class="authorDescription body article">Jennie Lucas's parents owned a bookstore and she grew up surrounded by books, dreaming about faraway lands. At twenty-two she met her future husband and after their marriage, she graduated from university with a degree in English. She started writing books a year later. Jennie won the Romance Writers of America&rsquo;s Golden Heart contest in 2005 and hasn&rsquo;t looked back since. Visit Jennie&rsquo;s website at: www.jennielucas.com</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Harlequin
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?3c88bda8